var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon16RobotDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28178_6024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69995 9L7.69995 7H16.3V9",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87205 19.7856C9.87205 20.7258 9.10986 21.488 8.16967 21.488C7.22947 21.488 6.46729 20.7258 6.46729 19.7856",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5327 19.7856C17.5327 20.7258 16.7705 21.488 15.8303 21.488C14.8901 21.488 14.1279 20.7258 14.1279 19.7856",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 12H2.5C1.94771 12 1.5 12.4477 1.5 13V16C1.5 16.5523 1.94772 17 2.5 17H3.9",
    stroke: "#46B476",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 17L21.3999 17C21.9522 17 22.3999 16.5523 22.3999 16L22.3999 13C22.3999 12.4477 21.9522 12 21.3999 12L19.9999 12",
    stroke: "#46B476",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3759 9.57129H6.62403C5.25369 9.57129 4.14282 10.4947 4.14282 11.6338V16.9374C4.14282 18.0764 5.25369 18.9999 6.62403 18.9999H17.3759C18.7462 18.9999 19.8571 18.0764 19.8571 16.9374V11.6338C19.8571 10.4947 18.7462 9.57129 17.3759 9.57129Z",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72094 15.9619C9.66113 15.9619 10.4233 15.1997 10.4233 14.2595C10.4233 13.3193 9.66113 12.5571 8.72094 12.5571C7.78074 12.5571 7.01855 13.3193 7.01855 14.2595C7.01855 15.1997 7.78074 15.9619 8.72094 15.9619Z",
    fill: "#46B476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2739 15.9619C16.2141 15.9619 16.9763 15.1997 16.9763 14.2595C16.9763 13.3193 16.2141 12.5571 15.2739 12.5571C14.3337 12.5571 13.5715 13.3193 13.5715 14.2595C13.5715 15.1997 14.3337 15.9619 15.2739 15.9619Z",
    fill: "#46B476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.07143C12.434 4.07143 12.7858 3.71965 12.7858 3.28571C12.7858 2.85178 12.434 2.5 12.0001 2.5C11.5661 2.5 11.2144 2.85178 11.2144 3.28571C11.2144 3.71965 11.5661 4.07143 12.0001 4.07143Z",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5V6",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28178_6024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16RobotDelivery);
export default __webpack_public_path__ + "static/media/icon16_robotDelivery.70122ca41671994bd150472eb9b2ed05.svg";
export { ForwardRef as ReactComponent };